import {
    getAuthenticated,
    putAuthenticated
} from '../../../../../services/RestTemplate';
import { RuleCategory } from '../../../../../services/RuleCategory';

const configApi = '/risk/config';

const getRiskConfigUrl = (riskCategory, jurisdictionCode) => {
    let url = configApi + `/${jurisdictionCode}`;
    switch (riskCategory) {
        case RuleCategory.ANTI_MONEY_LAUNDERING:
            return url + '/aml';
        case RuleCategory.RESPONSIBLE_GAMBLING:
            return url + '/rg';
        case RuleCategory.FRAUD:
            return url + '/fraud';
        default:
            return url;
    }
};

export function getRiskConfig(riskCategory, jurisdictionCode) {
    const riskConfigUrl = getRiskConfigUrl(riskCategory, jurisdictionCode);

    return getAuthenticated(riskConfigUrl);
}

export function updateRiskConfig(riskCategory, jurisdictionCode, config) {
    const riskConfigUrl = getRiskConfigUrl(riskCategory, jurisdictionCode);

    return putAuthenticated(riskConfigUrl, config);
}
